var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForemanPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4837"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M86.0879 59.8135C101.382 59.8135 113.781 58.0877 113.781 55.9588C113.781 53.8298 101.382 52.104 86.0879 52.104C70.7933 52.104 58.3945 53.8298 58.3945 55.9588C58.3945 58.0877 70.7933 59.8135 86.0879 59.8135Z",
    fill: "#EF8B06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M132.818 140.966H40L44.1929 106.409C44.8692 100.999 48.3181 96.2985 53.3225 94.1006C59.95 91.2265 69.1811 88.2847 77.364 86.053L95.9953 85.9854C104.246 88.217 113.206 91.1588 119.631 94.0668C124.534 96.2985 127.915 100.931 128.592 106.274L132.818 140.966Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1081_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1082_",
    d: "M96.435 77.0923V86.3234C96.435 86.3234 94.6091 96.6365 86.0542 98.361C77.1274 96.0279 75.7749 86.3234 75.7749 86.3234V77.0923H96.435Z",
    fill: "#F7CFA4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1080_",
    d: "M105.023 65.0547C107.32 65.0547 109.182 62.8142 109.182 60.0503C109.182 57.2864 107.32 55.0459 105.023 55.0459C102.726 55.0459 100.864 57.2864 100.864 60.0503C100.864 62.8142 102.726 65.0547 105.023 65.0547Z",
    fill: "#F7CFA4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1079_",
    d: "M67.7611 64.649C70.0581 64.649 71.9202 62.4084 71.9202 59.6445C71.9202 56.8807 70.0581 54.6401 67.7611 54.6401C65.4641 54.6401 63.6021 56.8807 63.6021 59.6445C63.6021 62.4084 65.4641 64.649 67.7611 64.649Z",
    fill: "#F7CFA4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1078_",
    d: "M75.7749 81.1839C78.7167 84.3961 82.3347 86.5264 86.2233 86.5264C90.0104 86.5264 93.527 84.4976 96.435 81.4205V77.1262H75.7749V81.1839Z",
    fill: "#E2AA6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1077_",
    d: "M68.1328 53.4565V60.0502C68.1328 70.059 76.2481 84.1931 86.2569 84.1931C96.2657 84.1931 104.381 70.059 104.381 60.0502V53.4565H68.1328Z",
    fill: "#F7CFA4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M116.757 113.611H56.0278V141H116.757V113.611Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M107.458 122.335H65.3262V140.966H107.458V122.335Z",
    fill: "#FF8B00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1069_",
    d: "M68.0315 113.611V88.7917C65.4617 89.6033 62.9257 90.4486 60.5249 91.294V113.611H68.0315Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1068_",
    d: "M112.496 113.611V91.1926C110.096 90.3135 107.56 89.4343 104.99 88.6228V113.611H112.496Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M58.4624 55.7221H113.917C113.342 54.9782 110.941 51.935 108.439 50.9206C108.439 50.9206 109.622 26.5072 86.2572 26H86.2233H86.1895C62.8244 26.5072 64.0078 50.9206 64.0078 50.9206C61.4042 51.935 59.0034 54.9782 58.4624 55.7221Z",
    fill: "#FFB600"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector 18",
    d: "M83 40.4674V44.7717H86.2283V48L91.7283 42.5H88.3804L94 37L83 40.4674Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 378",
    x: 34,
    y: 98,
    width: 105,
    height: 50,
    fill: "url(#paint0_linear_4489_21930)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4489_21930",
    x1: 86.5,
    y1: 98,
    x2: 86.5,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForemanPic);
export default __webpack_public_path__ + "static/media/foremanPic.075db1b8231fa7053d3ed2f1b4f120ab.svg";
export { ForwardRef as ReactComponent };